import templateStr from 'text!./tile.html';

export default [function () {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            tileTitle: '@',
            tileValue: '@',
            tileIcon: '@',
            tileHeaderColor: '@'
        },
        replace: true
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/TileDirective/Tile.js
// module id = 1769
// module chunks = 0